// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__zZIPY","summary":"CartItem_summary__upWbZ","price":"CartItem_price__RqELc","amount":"CartItem_amount__gQQ-I","actions":"CartItem_actions__2Ubc-"};